import { Button, Card, Form, Input, message, Select, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import apiClient from '../../api/client'
import { useAuthStore } from '../../stores/auth'

interface SetupValues {
  admin_email: string
  admin_password: string
  fqdn: string
  company_name?: string
  default_currency?: string
  license_key?: string
}

export default function SetupPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const setSetupCompleted = useAuthStore((s) => s.setSetupCompleted)

  const onFinish = async (vals: SetupValues) => {
    try {
      await apiClient.post('/api/v1/setup/complete', vals)
      setSetupCompleted(true)
      message.success(t('setup.successTitle'))
      navigate('/login')
    } catch (e) {
      const err = e as { response?: { data?: { message?: string } } }
      message.error(err.response?.data?.message || 'Setup failed')
    }
  }

  return (
    <div className="auth-shell">
      <Card className="auth-card max-w-520">
        <Typography.Title level={3} className="mt-0">
          {t('setup.title')}
        </Typography.Title>
        <Typography.Paragraph type="secondary">
          {t('setup.intro')}
        </Typography.Paragraph>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label={t('setup.adminEmail')}
            name="admin_email"
            rules={[{ required: true, type: 'email' }]}
          >
            <Input autoComplete="email" />
          </Form.Item>
          <Form.Item
            label={t('setup.adminPassword')}
            name="admin_password"
            rules={[{ required: true, min: 12 }]}
            help={t('setup.passwordRule')}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            label={t('setup.fqdn')}
            name="fqdn"
            rules={[{ required: true }]}
          >
            <Input placeholder="control.example.com" />
          </Form.Item>
          <Form.Item label={t('setup.companyName')} name="company_name">
            <Input placeholder="NetCell IT" />
          </Form.Item>
          <Form.Item
            label={t('setup.defaultCurrency')}
            name="default_currency"
            initialValue="EUR"
          >
            <Select
              options={[
                { value: 'EUR', label: 'EUR — Euro' },
                { value: 'USD', label: 'USD — US Dollar' },
                { value: 'CHF', label: 'CHF — Swiss Franc' },
                { value: 'GBP', label: 'GBP — British Pound' },
              ]}
            />
          </Form.Item>
          <Form.Item label={t('setup.licenseKey')} name="license_key">
            <Input placeholder="NETC-XXXX-XXXX-XX" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {t('setup.submit')}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}
